import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  inputContainers: {
    marginTop: 12,
    marginBottom: 24,
  },
  inputContainerLabel: {
    fontWeight: 'bold',
    marginLeft: 14,
    padding: 10,
    flex: 1,
  },
  inputContainerLabel2: {
    fontWeight: 'bold',
    marginLeft: 14,
    padding: 10,
  },
  inputContainerLabelwithInfo: {
    fontWeight: 'bold',
    flex: 1,
  },
  toolTipTitle: {
    fontSize: FontSizes.size16,
    color: theme.palette.themePrimary,
    paddingTop: 2,
    paddingLeft: 2,
    paddingRight: 2,
  },
  toolTipReference: {
    padding: 2,
    fontSize: FontSizes.size16,
    color: theme.palette.themePrimary,
    marginLeft: 'auto',
    borderWidth: 1,
    borderColor: theme.palette.themePrimary,
    borderStyle: 'solid',
    borderRadius: 5,
    textAlign: 'center',
  },
  textInputConatiner: {
    flex: 1,
    marginRight: 24,
    marginLeft: 24,
    paddingBottom: 8,
    overflow: 'hidden',
  },
  taDescriptionStyle: {
    flex: 1,
    marginRight: 24,
    marginLeft: 24,
    paddingBottom: 8,
    wordWrap: 'break-word',
  },
  textNotesInputConatiner: {
    flex: 1,
    marginRight: 24,
    marginLeft: 24,
    paddingBottom: 8,
  },
  twoInputContainer: {
    height: 60,
  },
  firstInputContainer: {
    flex: 1,
  },
 
  currency: {
    marginRight: 6,
    marginLeft: 24,
    paddingBottom: 8,
    fontWeight: 'bold',
  },
  poNumber: {
    fontSize: FontSizes.size20,
  },
  flex50: {
    flex: 0.5,
    width: '100%',
  },
}));
